/*
 * @Author: chj
 * @Date: 2024-10-17 14:34:47
 * @LastEditors: chj
 * @LastEditTime: 2024-10-17 14:36:00
 * @Description: 请填写简介
 */
import request from '@/utils/request'

// 图片信息查询
export function getHomeData(query) {
  return request({
    url: '/home/listHomeData',
    method: 'get',
    params: {
      ...query
    }
  })
}